module.exports = __webpack_public_path__ + "static/media/check.c64641a7.svg";